import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {notificationUrl} from './defines';
import {InAppNotification} from './models/InAppNotification';

@Injectable({
  providedIn: 'root'
})
export class InAppNotificationService {

  private notificationsSubject = new BehaviorSubject<InAppNotification[]>([]);
  notifications$ = this.notificationsSubject.asObservable();

  constructor(private http: HttpClient) {
  }

  refresh(): void {
    this.http.get<InAppNotification[]>(`${notificationUrl}/notifications/in-app/active`)
      .subscribe(notifications => this.notificationsSubject.next(notifications));
  }

  markAsRead(id: string): Observable<any> {
    return this.http.post(`${notificationUrl}/notifications/${id}/read`, {});
  }
}